<template>
    <div class="wrap-dashboard">
        <div class="content">
            <div class="summary-data">
                <div>Total Balance</div>
                <div class="nominal">
                    <b-spinner v-if="!totalBalance" small></b-spinner>
                    <span v-else>IDR {{ formatIDR(totalBalance.total_balance) }}</span>
                </div>
                <div>
                    <small>Last Update: {{ totalBalance.last_updated | formatDateTimeReal }}</small>
                </div>
            </div>
            <div class="d-flex justify-content-between mb-3">
                <div class="filter-sort">
                    <div class="filter">
                        <dropdown-directive position="left" top="2.5rem">
                            <template v-slot:buttonDropdown>
                                <button class="btn btn-filter">
                                    Filter By <span class="badge" v-if="countBadge != 0">{{ countBadge }}</span>
                                </button>
                            </template>
                            <template v-slot:menuDropdown>
                                <div>
                                    <div class="mt-3 ml-3 refresh-button" @click="resetFilter" v-if="paramsUrl.bank.length != 0 || paramsUrl.broker.length != 0">
                                        <img src="@/assets/icon_cms/refresh-circle.svg" alt="" />
                                        Reset Filter
                                    </div>
                                    <div class="wrap-filter-by">
                                        <div class="filter-by">
                                            <label for="">Bank</label>
                                            <dropdown-directive position="left" top="2.5rem" width="15rem">
                                                <template v-slot:buttonDropdown>
                                                    <div class="select-filter">
                                                        <div class="wrap-select-item">
                                                            <div v-if="paramsUrl.bank.length == 0">Select Bank</div>
                                                            <template v-else>
                                                                <div v-for="bank in paramsUrl.bank" :key="bank.bank_code" class="select-item">
                                                                    {{ bank.name }}
                                                                    <!-- <img src="@/assets/icon_cms/close.svg" alt="close" class="select-close" /> -->
                                                                </div>
                                                            </template>
                                                        </div>
                                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                                    </div>
                                                </template>
                                                <template v-slot:menuDropdown>
                                                    <ul class="p-2">
                                                        <li v-for="(dataBank, i) in dataListBank" :key="i">
                                                            <input
                                                                type="checkbox"
                                                                name="bank"
                                                                :value="dataBank"
                                                                v-model="paramsUrl.bank"
                                                                id="bank"
                                                                @change="filterByBank"
                                                            />
                                                            <label for="bank" class="ml-2">{{ dataBank.name }}</label>
                                                        </li>
                                                    </ul>
                                                </template>
                                            </dropdown-directive>
                                        </div>
                                        <div class="filter-by">
                                            <label for="">Broker</label>
                                            <dropdown-directive position="left" top="2.5rem" width="14rem">
                                                <template v-slot:buttonDropdown>
                                                    <div class="select-filter">
                                                        <div class="wrap-select-item">
                                                            <div v-if="paramsUrl.broker.length == 0">Select Bank</div>
                                                            <template v-else>
                                                                <div  v-for="broker in paramsUrl.broker" :key="broker.broker_code" class="select-item">
                                                                    {{ broker.broker_name }}
                                                                    <!-- <img src="@/assets/icon_cms/close.svg" alt="close" class="select-close" /> -->
                                                                </div>
                                                            </template>
                                                        </div>
                                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                                    </div>
                                                </template>
                                                <template v-slot:menuDropdown>
                                                    <div class="p-2">
                                                        <ul>
                                                            <li v-for="(dataBroker, i) in dataListBroker" :key="i">
                                                                <input
                                                                    type="checkbox"
                                                                    name="broker"
                                                                    id="broker"
                                                                    :value="dataBroker"
                                                                    v-model="paramsUrl.broker"
                                                                    @change="filterByBroker"
                                                                />
                                                                <label for="broker" class="ml-2">{{ dataBroker.broker_name }}</label>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </template>
                                            </dropdown-directive>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </dropdown-directive>
                    </div>
                    <div class="filter sort">
                        <dropdown-directive position="left" top="2.5rem">
                            <template v-slot:buttonDropdown><button class="btn btn-filter">Sort By</button></template>
                            <template v-slot:menuDropdown>
                                <div class="wrap-sort">
                                    <div class="sort-asc-dsc">
                                        <div class="form-group">
                                            <input type="radio" name="asc-desc" id="asc" value="asc" v-model="paramsUrl.order" @change="filterOrder" />
                                            <label for="asc">Ascending</label>
                                        </div>
                                        <div class="form-group">
                                            <input type="radio" name="asc-desc" id="dsc" value="desc" v-model="paramsUrl.order" @change="filterOrder" />
                                            <label for="dsc">Descending</label>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="form-group sort-by">
                                            <label for="">Sort By</label>
                                            <select name="" id="" v-model="paramsUrl.sortBy" @change="filterSortBy">
                                                <option value="" selected disabled>Select Field</option>
                                                <option value="created_at">Registration Date</option>
                                                <option value="hin">HIN</option>
                                                <option value="fullname">Fullname</option>
                                            </select>
                                            <img
                                                src="@/assets/icon_cms/close.svg"
                                                alt="close"
                                                class="icon-close"
                                                @click="resetSortBy"
                                                v-if="paramsUrl.sortBy != ''"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </dropdown-directive>
                    </div>
                </div>
                <div class="filter-search">
                    <input type="text" class="form-input" placeholder="input keyword" v-model="paramsUrl.keyword" @keyup="filterSearch" />
                    <img src="@/assets/icon_cms/search.svg" alt="" class="icon-input" />
                </div>
            </div>

            <div class="view-perpages">
                <select v-model="paramsUrl.perPage" @change="showDataRow">
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
                <span>&nbsp;entries per page</span>
            </div>
            <table>
                <thead>
                    <tr id="top">
                        <th scope="col">No</th>
                        <th scope="col">Broker</th>
                        <th scope="col">Name</th>
                        <th scope="col">HIN</th>
                        <th scope="col">Gold Balance (gr)</th>
                        <th scope="col">Bank</th>
                        <th scope="col">RPED</th>
                        <th scope="col">Balance</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody v-if="isloadData">
                    <tr>
                        <td colspan="10">
                            <b-spinner label="Loading..."></b-spinner>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr v-for="(data, i) in userDatas" :key="i" v-show="userDatas.length != 0">
                        <td>{{ (paramsUrl.currentPage - 1) * paramsUrl.perPage + (i + 1) }}</td>
                        <td>{{ data.broker_code == "BEI03002" || data.broker_code == "BEI03001" ? "ABI Commodity Futures" : "" }}</td>
                        <td>{{ formatCapitalize(data.fullname) }}</td>
                        <td>{{ data.trade_account.hin }}</td>
                        <td>
                            <b-spinner v-if="dataGram[i] == 'loading'" small></b-spinner>
                            <span v-else>{{ dataGram[i] }}</span>
                        </td>
                        <td>{{ data.bank_account[0].name }}</td>
                        <td>{{ data.bank_account[0].account_no }}</td>
                        <td>
                            <b-spinner v-if="dataBalance[i] == 'loading'" small></b-spinner>
                            <span v-else>{{  " " + dataBalance[i] }}</span>
                        </td>
                        <td>
                            <router-link :to="`/cash-management/participants/${data.trade_account.account_id}_${data.trade_account.hin}_${data.fullname}_${dataGram[i]}`">
                                <button class="btn btn-primary btn-sm" :disabled="dataGram[i] === 'loading'">Detail</button>
                            </router-link>
                        </td>
                    </tr>
                    <tr v-show="userDatas.length == 0">
                        <td colspan="10">No Data Available</td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-end mt-3">
                <b-pagination
                    v-model="paramsUrl.currentPage"
                    :total-rows="totalData"
                    :per-page="paramsUrl.perPage"
                    @change="handlePageChange"
                    aria-controls="new-table"
                    first-number
                    last-number
                    v-show="totalData > paramsUrl.perPage"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import DropdownDirective from "../../../components/dropdown/DropdownDirective.vue";
export default {
    components: { DropdownDirective },
    data() {
        return {
            loadingData: false,
            today: "",
            form: {
                startDate: "",
                endDate: "",
            },
            revenue: "",
            imgRevenue: null,
            role: "",
            displayCategory: false,
            selectedId: null,
            dataBalance: [],
            dataGram: [],
            // totalData: null,
            isLoaderBalance: false,
            paramsUrl: {
                currentPage: 1,
                perPage: 10,
                keyWord: "",
                broker: [],
                bank: [],
                sortBy: "hin",
                order: "asc",
                role: "ALL"
            },
            dataListBank: "",
            dataListBroker: "",
            timeOut: setTimeout(() => {}, 0),
            bagNominal: [],
            totalBalance: "",
            dataSummary: []
        };
    },
    mounted() {
        // this.getData(this.paramsUrl)
        this.newgetData(this.paramsUrl)

        axios.get("v2/attributes/bank_list").then((res) => {
            this.dataListBank = res.data.data.body;
        });
        axios.get("v2/attributes/broker_list").then((res) => {
            this.dataListBroker = res.data.data.body;
        });

        axios.get("v2/clearing/admin/get/total_balance").then((res) => {
            this.totalBalance = res.data.data.body;
        });
        
        this.getDataSummary(this.paramsUrl.currentPage)
        
    },
    methods: {
        getDataSummary(currentPage){
            let offset = (currentPage -1 ) * this.paramsUrl.perPage
            let url;
            let role = sessionStorage.getItem("role");
            if (role == 2 || role == 3) {
                url = "v2/clearing/admin/abx/get/list/summary_inventory?startDate&endDate&limit&offset" + offset + "&type=onexchange";
            } else {
                url = "v2/clearing/admin/get/list/summary_inventory?startDate&endDate&limit&offset=" + offset + "&type=onexchange";
            }
            axios.get(url).then(res=>{
                this.dataSummary = res.data.data.body
            })

        },
        async newgetData(paramsUrl){
            let username = sessionStorage.getItem("username");
            if(username == 'admin_abx') {
                this.paramsUrl.role = 'ALL'
            } else {
                this.paramsUrl.role = 'PC'
            }
            const response = await this.$store.dispatch('getTradeAccount', paramsUrl);
            this.dataGram = response.map(() => "loading");
            this.dataBalance = response.map(() => "loading");

            const gramPromises = response.map((item, i) => {
                const isBrokerLP = item.trade_account.hin.slice(0, 2) === 'LP';
                if (isBrokerLP) {
                    return axios.get('/v2/clearing/admin/get/total_gold?hin=' + this.dataSummary[i].depositor).then(resLP => {
                        return {
                            index: i,
                            value: this.formatIDR(this.dataSummary[i].weight - resLP.data.data.body.netting)
                        }
                    });
                } else {
                    return axios.get("/v2/clearing/admin/get/total_gold?account_id=" + item.trade_account.account_id).then(resGram => {
                        return {
                            index: i,
                            value: this.formatIDR(resGram.data.data.body.total_gram)
                        }
                    });
                }
                    
            });

            const balancePromises = response.map((item, i) => {
                return axios.get("/v2/clearing/admin/get/account_balance?account_no=" + item.bank_account[0].account_no)
                    .then(resbalance => {
                        let balance = resbalance.data.data.body.Balance;
                        let currency = resbalance.data.data.body.Currency
                        return {
                            index: i,
                            value: currency + ' ' + this.formatIDR(balance)
                        }
                    })
                    .catch(() => {
                        return {
                            index: i,
                            value: ""
                        }
                    });
            });

            const gramResults = await Promise.all(gramPromises);
            const balanceResults = await Promise.all(balancePromises);

            gramResults.forEach(result => {
                this.$set(this.dataGram, result.index, result.value);
            });

            balanceResults.forEach(result => {
                this.$set(this.dataBalance, result.index, result.value);
            });
        },
        getData(paramsUrl){
            let username = sessionStorage.getItem("username");
            if(username == 'admin_abx') {
                this.paramsUrl.role = 'ALL'
            } else {
                this.paramsUrl.role = 'PC'
            }
            this.$store.dispatch("getTradeAccount", paramsUrl).then((res) => {
            for (let i = 0; i < res.length; i++) {
                this.$set(this.dataGram, i, "loading");
                this.$set(this.dataBalance, i, "loading");

                let isBrokerLP = res[i].trade_account.hin.slice(0, 2)

                if(isBrokerLP == 'LP'){
                    for(let k = 0; k< this.dataSummary.length; k++){
                        axios.get('/v2/clearing/admin/get/total_gold?hin=' + this.dataSummary[k].depositor).then(resLP=>{
                            let dataGramLP = this.dataSummary[i].weight - resLP.data.data.body.netting
                            this.$set(this.dataGram, i, this.formatIDR(dataGramLP))
                        })
                    }
                } else {
                    axios.get("/v2/clearing/admin/get/total_gold?account_id=" + res[i].trade_account.account_id).then((resGram) => {
                        let totalGram = resGram.data.data.body.total_gram;
                        this.$set(this.dataGram, i, this.formatIDR(totalGram));
                    });

                }

                axios
                    .get("/v2/clearing/admin/get/account_balance?account_no=" + res[i].bank_account[0].account_no)
                    .then((resbalance) => {
                        let balance = resbalance.data.data.body.Balance;
                        let currency = resbalance.data.data.body.Currency
                        let dataShow = currency + ' ' + this.formatIDR(balance)
                        this.$set(this.dataBalance, i,  dataShow);
                    })
                    .catch(() => {
                        this.$set(this.dataBalance, i, "");
                    });
            }
        });
        },
        formatCapitalize(value) {
            let string = value.toLowerCase();
            return string.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
        },
        filterByBank() {
            this.paramsUrl.currentPage = 1
            this.getData(this.paramsUrl)
        },
        filterByBroker() {
            this.paramsUrl.currentPage = 1
            this.getData(this.paramsUrl)
        },
        filterOrder() {
            this.paramsUrl.currentPage = 1
            this.getData(this.paramsUrl)
        },
        filterSortBy() {
            this.paramsUrl.currentPage = 1
            this.getData(this.paramsUrl)
        },
        filterSearch(event) {
            this.paramsUrl.keyWord = event.target.value;
            this.paramsUrl.currentPage = 1
            clearTimeout(this.timeOut);
            this.timeOut = setTimeout(() => {
                this.getData(this.paramsUrl)
            }, 700);
        },
        resetFilter() {
            this.paramsUrl.currentPage = 1
            this.paramsUrl.bank = [];
            this.paramsUrl.broker = [];
            this.getData(this.paramsUrl)

        },
        resetSortBy() {
            this.paramsUrl.currentPage = 1
            this.paramsUrl.sortBy = "";
            this.getData(this.paramsUrl)

        },
        handlePageChange(value) {
            this.paramsUrl.currentPage = value;
            this.getData(this.paramsUrl)

            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        showDataRow() {
            this.currentPage = 1;
            this.getData(this.paramsUrl)

        },
        formatPrice(value) {
            let val = value / 1;
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        formatIDR(value) {
            let val = (value / 1).toFixed(2).replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        select(itemId) {
            this.selectedId = itemId;
            this.displayCategory = !this.displayCategory;
        },
        selectedDropdown(value, img) {
            this.revenue = value;
            this.imgRevenue = img;
        },
    },
    computed: {
        userDatas() {
            // return this.$store.state.cashModule.tradeAccountData;
            return this.$store.getters.getDataTrade;
        },
        totalData() {
            return this.$store.state.cashModule.totalTradeAccountData;
        },
        isloadData() {
            return this.$store.state.cashModule.isLoadingData;
        },

        countBadge() {
            let nominal = this.paramsUrl.bank.length + this.paramsUrl.broker.length;
            return nominal;
        },
    },
};
</script>

<style scoped>
/*.wrap-dashboard {
  min-height: 100vh;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}*/

.summary-data {
    /* box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.2); */
    transition: 0.3s;
    padding: 1rem;
    border-radius: 0.5rem;
    cursor: pointer;
    min-width: 20%;
    max-width: 30%;
    border: solid 1px #dddddd;
    margin-bottom: 1rem;
}

.summary-data .nominal {
    font-size: 2rem;
    font-weight: bold;
}

.summary-data:hover {
    /* box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.2); */
    box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.2);
}

.filter-sort {
    display: flex;
    gap: 1rem;
}

.filter-search {
    width: 25%;
    position: relative;
}

.icon-input {
    position: absolute;
    top: 0.65rem;
    right: 0.65rem;
}

.select-filter {
    border: solid 1px #ddd;
    padding: 0.5rem 0.75rem;
    border-radius: 0.25rem;
    font-size: 13px;
    width: 10rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: auto;
}

/* width */
.select-filter::-webkit-scrollbar {
    height: 3px;
}

/* Track */
.select-filter::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
.select-filter::-webkit-scrollbar-thumb {
    background: #888;
}

/* Handle on hover */
.select-filter::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.select-filter i {
    font-size: 1.15rem;
}

.wrap-select-item {
    display: flex;
    gap: 0.5rem;
}

.select-item {
    border: 1px solid #ddd;
    border-radius: 15px;
    padding: 1px 0.5rem;
    white-space: nowrap;
    width: 7rem;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 11px;
    position: relative;
    transition: width 1s;
}

.select-item:hover {
    position: absolute;
    top: 9px;
    background-color: #ffff;
    width: 11.5rem;
    min-width: 11.5rem;
    z-index: 1;
    transition: width 1s;
}

.select-close {
    position: absolute;
    right: 0.5rem;
    top: 0.3rem;
    width: 0.5rem;
    cursor: pointer;
}

.refresh-button {
    cursor: pointer;
    color: #2e75b6;
    width: 26%;
}

.btn-filter {
    box-shadow: unset;
    background-color: var(--primary-color);
    color: #ffffff;
    font-size: 14px;
    border-radius: 5px;
}

.wrap-filter-by {
    padding: 1rem;
    display: flex;
    gap: 1rem;
}

.filter-by label:first-child {
    font-weight: bold;
}

.filter-by ul {
    margin: unset;
}

.wrap-sort {
    padding: 1rem;
    width: 16rem;
}

.badge {
    width: 1rem;
    height: 1rem;
    background: #fff;
    color: #2e75b6;
    border-radius: 50%;
    font-size: 0.69rem;
}

.sort-asc-dsc {
    display: flex;
    justify-content: space-around;
    border-bottom: solid 1px #dddddd;
    margin-bottom: 1rem;
}

.icon-close {
    position: absolute;
    right: 1.5rem;
    top: 2.25rem;
    width: 0.75rem;
    cursor: pointer;
}

input[type="radio"] {
    margin-right: 0.5rem;
}
.sort-by label {
    font-weight: bold;
    display: block;
}

.sort-by select {
    width: 100%;
}

.top-title {
    display: flex;
    justify-content: space-between;
}

.bagi {
    height: 30px;
}

.sort-date {
    display: flex;
    gap: 1rem;
}

.form-group {
    margin-bottom: unset;
    position: relative;
}

.form-input {
    border: solid 1px #ccc;
    height: 2.5rem;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 12px;
    width: 100%;
}

.form-input::placeholder {
    color: #ccc;
}

/* .bagi-menu {
  background-image: url("../assets/logo_agi.png");
} */

select#revenue option[value="bank"] {
    background-image: url("../../../assets/logo_agi.png");
}

.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

.option-table {
    background: #f8f8f8;
    border: none;
    width: 100%;
}

.icon-trade {
    width: 25px;
}

.footer {
    background: var(--primary-color);
    color: white;
    padding: 20px 47px;
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    height: 62px;
}

.wrap-input {
    margin-bottom: 10px;
}
.label-input {
    width: 108px;
}

select {
    border-radius: 3px;
    border-color: #a5a5a5a5;
    padding: 3px;
}

.card {
    width: 314px;
    font-size: 14px;
    border-radius: 10px;
}

.card-header {
    padding: 1rem;
}

.buyer,
.seller,
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title {
    font-size: 12px;
    position: relative;
    left: 20px;
}

.title::before {
    content: "";
    position: absolute;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: var(--scondary-color);
    left: -17px;
    top: 3px;
}

.buyer {
    margin-bottom: 20px;
}

.content-right {
    text-align: right;
}

.amount {
    font-weight: bold;
}

.btn-primer {
    background: var(--scondary-color);
    border: none;
    color: #ffffff;
    padding: 5px 25px;
    border-radius: 5px;
    cursor: pointer;
}

.btn-primer:hover {
    background-color: var(--scondary-color-hover);
}

.button-dropdown {
    width: 100% !important;
}

.dropdown-toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}

.item-dropdown {
    cursor: pointer;
    font-size: 14px;
    text-align: left;
    display: flex;
    gap: 0.6em;
}

.item-dropdown:hover {
    background: #f2f2f2;
}

.btn-group > .btn {
    box-shadow: none;
}

.dropdown-menu {
    width: 100%;
    font-size: 13px;
    transform: translate3d(-30px, 21px, 0px);
}

.dropdown-menu.show {
    transform: translate3d(-30px, 21px, 0px) !important;
}

.dropdown-item {
    cursor: pointer;
    display: flex;
    gap: 0.5rem;
    padding: 0.25rem 0.7rem;
}

.img-revenue {
    height: 15px;
}

.wrap-img {
    width: 33px;
    text-align: center;
}

.wrap-img img {
    height: 15px;
}
</style>
